import i18n from 'i18next';

const loadedNamespaces = new Set(['translation']);

export const loadNamespace = async (namespace: string) => {
  if (loadedNamespaces.has(namespace)) {
    return;
  }

  try {
    const translations = await import(
      `@tempo-io/translations/locales/en/generated/${namespace}.nested.json`
    );
    i18n.addResourceBundle('en', namespace, translations.default);
    loadedNamespaces.add(namespace);
  } catch {
    // Silently fail for missing namespaces
  }
};

export const ensureNamespaceLoaded = async (namespace: string) => {
  await loadNamespace(namespace);
  await i18n.loadNamespaces(namespace);
};
